import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "logix-theme"
const LIGHT = "light"
const DARK = "business"

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon", "button"]

  connect() {
    this.applyTheme(this.currentTheme)
  }

  toggle() {
    const next = this.currentTheme === DARK ? LIGHT : DARK
    localStorage.setItem(STORAGE_KEY, next)
    this.applyTheme(next)
    document.dispatchEvent(new CustomEvent("theme-changed", { detail: { theme: next } }))
  }

  get currentTheme() {
    return localStorage.getItem(STORAGE_KEY) || LIGHT
  }

  applyTheme(theme) {
    document.documentElement.dataset.theme = theme
    const isDark = theme === DARK

    // Swap icon visibility
    if (this.hasLightIconTarget) this.lightIconTarget.classList.toggle("theme-icon-inactive", !isDark)
    if (this.hasDarkIconTarget) this.darkIconTarget.classList.toggle("theme-icon-inactive", isDark)

    // Update button tooltip
    if (this.hasButtonTarget) {
      const label = isDark ? "Switch to light mode" : "Switch to dark mode"
      this.buttonTarget.setAttribute("title", label)
      this.buttonTarget.setAttribute("aria-label", label)
    }

    // Update theme-color meta tag
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) {
      const lightColor = meta.dataset.lightColor || "#570df8"
      meta.setAttribute("content", isDark ? "#1d232a" : lightColor)
    }
  }
}
